import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
// import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './utils/theme';
import Dashboard from './pages/Dashboard';
import RequirementUpload from './pages/RequirementUpload';
import ProjectView from './pages/ProjectView';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';

// Import AWS Amplify configuration
import './config/amplify';

function App() {
  // Initialize any app-wide configurations or effects here
  useEffect(() => {
    document.title = 'R2C Workbench - Transform Requirements into Code';
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/upload" element={<RequirementUpload />} />
            <Route path="/projects/:projectId" element={<ProjectView />} />
          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;